<!-- DeleteServiceModal.vue -->

<template>

  <div class="modal" id="deleteServiceModal" tabindex="-1" aria-labelledby="deleteServiceModalLabel" aria-hidden="true" ref="deleteServiceModal">
    <div class="modal-dialog">

      <div class="modal-content shadow shadow-lg">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Delete Service</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="!isSubmitting">
            Are you sure you want to delete this service?
          </div>

          <div v-else>
            Deleting service and fetching list of services...
          </div>
        </div>

        <div class="modal-footer">
          <span v-if="isDeleting('deletingService') || isSubmitting" class="ms-2 spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="isDeleting('deletingService') || isSubmitting">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteRecord" :disabled="isDeleting('deletingService') || isSubmitting">Delete</button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
/* global bootstrap */
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteServiceModal',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
    serviceId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      modalInstance: null,
    };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',

      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    openModal() {
      if (!this.modalInstance) {
        const modalElement = this.$refs.deleteServiceModal;
        this.modalInstance = new bootstrap.Modal(modalElement);
      }
      this.modalInstance.show();
    },

    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    async deleteRecord() {
      this.isSubmitting = true;

      try {
        await this.$store.dispatch('deleteRecord', {
          tableName: 'Services',
          recordId: this.serviceId,
          deletingStateVariable: 'deletingService',
        });

        await this.$store.dispatch('fetchRecords', {
          tableName: 'Services',
          stateVariable: 'services',
          fetchingStateVariable: 'fetchingServices',
        }),

        this.$emit('showAlert', 'success', 'Successfully deleted service');
        this.closeModal();

        this.$router.push('/settings/services');

      } catch (error) {
        this.$emit('showAlert', 'danger', 'Error deleting service: ' + error.message);
        console.error('Error deleting service: ', error);

      } finally {
        this.isSubmitting = false;
      }
    },
  },

  async mounted() { },

  created() { },
};
</script>